module.exports = __webpack_public_path__ + "static/media/fsc8.52725881.svg";